var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "23px",
    viewBox: "0 0 18 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sheet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[A]]-Manage-content",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-edit-category",
    transform: "translate(-443.000000, -204.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(429.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.854,33.264 C24.578,33.264 24.354,33.04 24.354,32.764 L24.354,26.764 C24.354,26.487 24.578,26.264 24.854,26.264 L30.854,26.264 C31.131,26.264 31.354,26.487 31.354,26.764 C31.354,27.04 31.131,27.264 30.854,27.264 L25.354,27.264 L25.354,32.764 C25.354,33.04 25.131,33.264 24.854,33.264",
    id: "Fill-505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.022,32.264 L24.647,32.264 L30.354,26.557 L30.354,12.735 L15.022,12.735 L15.022,32.264 Z M24.854,33.264 L14.522,33.264 C14.246,33.264 14.022,33.04 14.022,32.764 L14.022,12.235 C14.022,11.959 14.246,11.735 14.522,11.735 L30.854,11.735 C31.131,11.735 31.354,11.959 31.354,12.235 L31.354,26.764 C31.354,26.896 31.301,27.023 31.208,27.117 L25.208,33.117 C25.114,33.211 24.987,33.264 24.854,33.264 L24.854,33.264 Z",
    id: "Fill-506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.772,16.528 L17.897,16.528 C17.621,16.528 17.397,16.305 17.397,16.028 C17.397,15.752 17.621,15.528 17.897,15.528 L23.772,15.528 C24.049,15.528 24.272,15.752 24.272,16.028 C24.272,16.305 24.049,16.528 23.772,16.528",
    id: "Fill-507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.647,18.945 L17.897,18.945 C17.621,18.945 17.397,18.722 17.397,18.445 C17.397,18.169 17.621,17.945 17.897,17.945 L27.647,17.945 C27.924,17.945 28.147,18.169 28.147,18.445 C28.147,18.722 27.924,18.945 27.647,18.945",
    id: "Fill-508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.647,21.362 L17.897,21.362 C17.621,21.362 17.397,21.139 17.397,20.862 C17.397,20.586 17.621,20.362 17.897,20.362 L27.647,20.362 C27.924,20.362 28.147,20.586 28.147,20.862 C28.147,21.139 27.924,21.362 27.647,21.362",
    id: "Fill-509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.979,23.779 L17.897,23.779 C17.621,23.779 17.397,23.556 17.397,23.279 C17.397,23.003 17.621,22.779 17.897,22.779 L21.979,22.779 C22.256,22.779 22.479,23.003 22.479,23.279 C22.479,23.556 22.256,23.779 21.979,23.779",
    id: "Fill-510"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.3b5ca679a3c5f8959262048e134f74b0.svg";
export { ForwardRef as ReactComponent };